import Services from '../Service'

// Grupos de usuários (#64). Não confundir com os grupos de PRODUTO, que são
// uma das dimensões de permissão (`getOptionAtributos({ tipo: 'grupos' })`).
class AdminGrupoService extends Services {
  constructor() {
    super()
    this.resource = 'admin/grupos'
  }

  async getGrupos(params) {
    return await this.getAPI(this.resource, params)
  }

  async getGrupo(id) {
    return await this.getAPI(`${this.resource}/${id}`)
  }

  async createGrupo(payload) {
    return await this.postAPI(this.resource, payload)
  }

  async updateGrupo(payload, id) {
    return await this.updateAPI(payload, id)
  }

  // `mover_para` vai no corpo do DELETE: é obrigatório quando o grupo tem
  // membros, e eles são movidos para lá na mesma transação.
  async deleteGrupo(id, moverPara = null) {
    try {
      const { data } = await this._http.delete(`${this.resource}/${id}`, {
        data: moverPara ? { mover_para: moverPara } : {},
      })
      return data
    } catch (e) {
      return this.handlingError(e)
    }
  }

  async getPermissions(id) {
    return await this.getAPI(`${this.resource}/${id}/permissions`)
  }
}

export default new AdminGrupoService()
